import httpClient from 'utils/api.utils';
import config from 'utils/config';
import storage from '@xto10x/storage/lib/storage';
import { StorageKey } from 'utils/constants';

export const getIsPeopleCuesOrg = () =>
  storage.getDataFromLocal(StorageKey.IS_PEOPLE_CUES_ORG) ||
  ['cues', 'localhost'].some(origin =>
    window.location.hostname.startsWith(origin)
  );

const userApi = {
  getUserList: ({ burstCache }) =>
    httpClient.get(
      `${config.blitzApiUrl}/v2/blitz/users/all-user-details`,
      {
        'burst-cache': burstCache
      },
      {},
      {},
      getIsPeopleCuesOrg()
    ),
  getUserListV3: ({ burstCache, includeDemographics = false }) =>
    httpClient.get(
      `${config.blitzApiUrl}/v3/blitz/users/all-user-details`,
      {
        'burst-cache': burstCache,
        include_demographics: includeDemographics
      },
      {},
      {},
      getIsPeopleCuesOrg()
    ),
  getUserInfo: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/info`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getUserModules: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/product-details`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getUserByReferenceID: user_reference_id =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/${user_reference_id}?attribute_name=USER_REFERENCE_ID`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),
  getUserWithHrbpByReferenceID: user_reference_id =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/${user_reference_id}?attribute_name=USER_REFERENCE_ID&include_hrbp_details=true`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),
  getUserReferenceIdByEmail: email =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/ref/${email}`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  updateUser: requestBody =>
    httpClient.put(
      `${config.blitzApiUrl}/v1/blitz/users`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  updateOkrUser: (requestBody, id) =>
    httpClient.put(
      `${config.blitzApiUrl}/v1/blitz/users${id ? `?NEW_OWNER_ID=${id}` : ''}`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  sendHelpQuery: requestBody =>
    httpClient.post(
      `${config.blitzApiUrl}/v1/support/create-ticket`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  checkFeatureTooltip: requestBody =>
    httpClient.post('/v1/tooltip', requestBody),

  registerUserAccess: () => httpClient.post('/v1/access').catch(() => null),

  getSettings: () => httpClient.get('/v1/settings'),

  getSettingUsedParams: () => httpClient.get('/v1/settings/used-params'),

  updateOrgSettings: requestBody =>
    httpClient.post('/v1/settings', requestBody),

  inviteUsers: (invite_email_enabled = true, requestBody) =>
    httpClient.post(
      `${config.blitzApiUrl}/v1/blitz/users/invite${
        !invite_email_enabled ? '?invite_email_enabled=false' : ''
      }`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  updateManager: requestBody =>
    httpClient.post(
      `${config.blitzApiUrl}/v1/blitz/users/update-manager`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  updateDesignation: requestBody =>
    httpClient.put(
      `${config.blitzApiUrl}/v1/blitz/users/designation`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getUserDirectReporte: user_reference_id =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/${user_reference_id}/direct-reports`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getOrgLocation: org_reference_id =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/org/${org_reference_id}/location`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  // saveUserOrgLocation: requestBody =>
  //   httpClient.put(
  //     `users/${requestBody.user_reference_id}/update-location`,
  //     requestBody
  //   ),

  getFounderDetails: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/org/founder/details`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getDirectReportsInOrgHierarchy: user_reference_id =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/${user_reference_id}/direct-reports`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  validateHierarchy: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/org/validate/hierarchy`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getL1Leaders: () =>
    httpClient.get(
      `${config.peopleApiUrl}/org/l1Leader/details`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  createFunctionWithOwner: requestBody =>
    httpClient.post(`${config.peopleApiUrl}/function`, requestBody),

  getFunctionsWithOwner: () =>
    httpClient.get(`${config.peopleApiUrl}/function`),

  updateFunctionOwners: requestBody =>
    httpClient.put(`${config.peopleApiUrl}/function/map-owners`, requestBody),

  removeFunctionOwner: functionRefId =>
    httpClient.put(
      `${config.peopleApiUrl}/function/${functionRefId}/remove-users`
    ),

  getOrgDemographicsMasterData: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/user-demographics/master-data`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  updateUserDemographicsData: requestBody =>
    httpClient.put(
      `${config.blitzApiUrl}/v1/blitz/users/user-demographics`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getOrgDemographicWhitelistedKeys: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/user-demographics/org-demographic-keys`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  updateRoles: roles =>
    httpClient.put(
      `${config.blitzApiUrl}/v2/blitz/users`,
      roles,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getAllHrbps: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/hrbps`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  updateHrbps: requestBody =>
    httpClient.put(
      `${config.blitzApiUrl}/v1/blitz/users/hrbps`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  removeHrbps: requestBody =>
    httpClient.delete(
      `${config.blitzApiUrl}/v1/blitz/users/hrbps`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  updateUserHrbpMapping: (managerId, requestBody) =>
    httpClient.put(
      `${config.blitzApiUrl}/v1/blitz/users/${managerId}/hrbp`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getCurrentUserHrbpDetails: userReferenceId =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/hrbp/${userReferenceId}`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getIsOngoingUserInvite: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/on-going-user-async-invite`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getUserReporteesByPersona: (persona, includeRevokedUsers = true) =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/user-reportees-by-persona?persona=${persona}&includeRevokedUsers=${includeRevokedUsers}`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  bulkInviteUsersAsync: (invite_email_enabled = true, requestBody) =>
    httpClient.post(
      `${config.blitzApiUrl}/v1/blitz/users/bulk-invite-async${
        !invite_email_enabled ? '?invite_email_enabled=false' : ''
      }`,
      requestBody,
      {},
      {},
      getIsPeopleCuesOrg()
    ),

  getPendingTasks: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/tasks/pending-tasks`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),
  getUserAttributes: userId =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/users/user-demographics`,
      {
        attribute_name: 'USER_REFERENCE_ID',
        attribute_value: userId
      },
      {},
      {},
      getIsPeopleCuesOrg()
    ),
  getAdvancedOKRUsers: moduleType =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/org/module-access/${moduleType}/users?burst-cache=true`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    )
};

export default userApi;
